import {getLocalTimeZoneName, padDateString, removeExtraSpaces} from './shared/functions';
import {setSystemToLowercase} from './shared/serverFunctions';
import Config from './messages';

/**
 * Products
 * Product Units
 * Product Types
 * Product Types for Product: Product Categories
 * Product Categories by Type
 * All Product Categories
 * Product Aliases/SKUs
 * Discounts
 *
 * GET_LIST, GET_ONE, GET_MANY, GET_MANY_REFERENCE, CREATE, UPDATE, DELETE
 */
export const RESOURCES = {
    "Products": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let uri;
            let allowSearch = params.filter.search_name_submit;
            let searchTerm = params.filter.search_name;
            let productType = params.filter.type;
            if (productType) {
                params.type = productType;
            }
            let categoryId = params.filter.category_id;
            if (searchTerm && allowSearch) {
                // If a search term is passed, search Products by Name
                uri = localStorage.getItem('server') + "/api/v5/search/q/" + system + "/products/byName/" + encodeURI(searchTerm);
            } else if (categoryId) {
                // If a Category ID is passed, get Products by Type and Category
                params.category_id = categoryId;
                uri = localStorage.getItem('server') + "/api/v5/admin/getProductsByTypeAndCategory/" + system + "/" + params.type + "/" + params.category_id;
            } else {
                // Get all Products by Type
                uri = localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/productsByType/" + system + "/" + params.type + "?params=" + JSON.stringify(params);
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Products",
                "uri": uri
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Product",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/productByTypeAndId/" + system + "/" + params.type + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertProduct"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let productParams = populateProductParams(params);
            return {
                "type": "upsert",
                "data": productParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertProduct"
            }
        }
    },
    "ProductNames": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Products",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/productNames/" + system + "?params=" + JSON.stringify(params)
            }
        }
    },
    "ProductUnits": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let productType = params.filter.type;
            if (productType) {
                params.type = productType;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Product Units",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/systemProductUnitsByType/" + system + "/" + params.type + "?params=" + JSON.stringify(params)
            }
        },
        GET_MANY_REFERENCE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Product Units",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/systemProductUnitsByType/" + system + "/" + params.type
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            if (!params.id && params.product_unit_id) {
                params.id = params.product_unit_id;
            }
            return {
                "type": "item",
                "method": "GET",
                "title": "Product Unit",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/systemProductUnitByTypeId/" + system + "/" + params.type + "/" + params.id
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let productUnitParams = populateProductUnitParams(params, false);
            return {
                "type": "upsert",
                "data": productUnitParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertSystemProductUnit"
            }
        }
    },
    "ProductUnitCreate": {
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Product",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/productByTypeAndId/" + system + "/" + params.type + "/" + params.id
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let productUnitParams = populateProductUnitParams(params, true);
            return {
                "type": "upsert",
                "data": productUnitParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertSystemProductUnit"
            }
        }
    },
    "ProductUnitsForAlias": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let productType = params.filter.type;
            if (productType) {
                params.type = productType;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Product Units",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/systemProductUnitsByTypeForAlias/" + system + "/" + params.type + "?params=" + JSON.stringify(params)
            }
        }
    },
    "ProductUnitsByTypeUnitType": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let productType = params.filter.type;
            if (productType && !params.type) {
                params.type = productType;
            }
            let unitType = params.filter.unit_type;
            if (unitType && !params.unit_type) {
                params.unit_type = unitType;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Product Units",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/systemProductUnitsByTypeUnitType/" + system + "/" + params.type + "/" + params.unit_type + "?params=" + JSON.stringify(params)
            }
        }
    },
    "ProductUnitsByTypeProductId": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let productType = params.filter.type;
            if (productType) {
                params.type = productType;
            }
            let productId = params.filter.id;
            if (productId) {
                params.id = productId;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Product Units",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/systemProductUnitsByTypeProductId/" + system + "/" + params.type + "/" + params.id
            }
        }
    },
    "ProductTypes": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "list",
                "method": "GET",
                "title": "Product Types",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/productTypes/" + system + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Product Type",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/productType/" + system + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/productType"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/productType"
            }
        }
    },
    "ProductCategories": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let productType = params.filter.type;
            if (productType) {
                params.type = productType;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Product Categories",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/systemProductCategoriesByType/" + system + "/" + params.type + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            return {
                "type": "item",
                "method": "GET",
                "title": "Product Category",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/systemProductCategoryByTypeId/" + system + "/" + params.type + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            let categoryParams = populateProductCategoryParams(params);
            return {
                "type": "upsert",
                "data": categoryParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertSystemProductCategory"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let categoryParams = populateProductCategoryParams(params);
            return {
                "type": "upsert",
                "data": categoryParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/upsertSystemProductCategory"
            }
        }
    },
    "ProductCategoryNames": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let productType = params.filter.type;
            if (productType) {
                params.type = productType;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Product Categories",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/systemProductCategoryNamesByType/" + system + "/" + params.type + "?params=" + JSON.stringify(params)
            }
        },
    },
    "ProductAliases": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let productType = params.filter.type;
            if (productType) {
                params.type = productType;
            }
            let productUnitType = params.filter.unit_type;
            if (productUnitType) {
                params.unit_type = productUnitType;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Aliases",
                "uri": localStorage.getItem('server') + "/api/v5/admin/getSkusByUnitType/" + system + "/" + params.type + "/" + params.unit_type
            }
        },
        GET_MANY: function (params) {
            const system = setSystemToLowercase();
            let productType = params.filter.type;
            if (productType) {
                params.type = productType;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Aliases",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/AdminDomainManager/aliasesByType/" + system + "/" + params.type + "?params=" + JSON.stringify(params)
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            if (params && !params.id && params.sku) {
                params.id = params.sku;
            }
            return {
                "type": "item",
                "method": "GET",
                "title": "Product Unit",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/alias/" + system + "/" + params.type + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            return {
                "type": "upsert",
                "data": params.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/alias"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let aliasParams = populateAliasParams(params);
            return {
                "type": "upsert",
                "data": aliasParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/alias"
            }
        },
        DELETE: function (params) {
            params.previousData.system = setSystemToLowercase();
            return {
                "type": "delete",
                "data": params.previousData,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/ProductDomainManager/deleteAlias"
            }
        }
    },
    "Discounts": {
        GET_LIST: function (params) {
            const system = setSystemToLowercase();
            let productType = params.filter.type;
            if (productType) {
                params.type = productType;
            }
            return {
                "type": "list",
                "method": "GET",
                "title": "Discounts",
                "uri": localStorage.getItem('server') + "/api/v5/admin/getDiscounts/" + system + "/" + params.type
            }
        },
        GET_ONE: function (params) {
            const system = setSystemToLowercase();
            if (!params.type) {
                params.type = Config.fuse.discount.type;
            }
            return {
                "type": "item",
                "method": "GET",
                "title": "Discount",
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/DiscountDomainManager/systemDiscountById/" + system + "/" + params.type + "/" + params.id
            }
        },
        CREATE: function (params) {
            params.data.system = setSystemToLowercase();
            let discountParams = populateDiscountParams(params);
            return {
                "type": "upsert",
                "data": discountParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/DiscountDomainManager/systemDiscount"
            }
        },
        UPDATE: function (params) {
            params.data.system = setSystemToLowercase();
            let discountParams = populateDiscountParams(params);
            return {
                "type": "upsert",
                "data": discountParams.data,
                "uri": localStorage.getItem('server') + "/api/v4/Domain/Manager/DiscountDomainManager/systemDiscount"
            }
        }
    },
};

/*
 * Remove unused values for Products
 */
const populateProductParams = (params) => {
    // Remove unused form objects
    delete params.data.category;

    return params;
};

/*
 * Modify values for Product Units
 */
const populateProductUnitParams = (params, is_creating = false) => {
    // Populate required fields
    if (is_creating) {
        params.data.id = params.data.product_unit_id;
    }
    const unit_type = params.data.unit_type;
    if (unit_type && unit_type === 'Piece') {
        params.data.piece_unit = null;
        params.data.units_per_scan = 1;
    } else {
        params.data.default_unit = false;
    }
    if (params.data.parent_default_unit && !params.data.default_unit) {
        params.data.default_unit = false;
    }

    // Remove unused form objects
    if (is_creating) {
        delete params.data.product_unit_id;
        delete params.data.product_unit_id_check;
        delete params.data.price.hidden;
    }
    if (params.data.parent_product_units) {
        delete params.data.parent_product_units;
        delete params.data.parent_default_unit;
    }
    delete params.data.default_case_qty;
    delete params.data.units_per_scan_piece;

    return params;
};

/*
 * Populate values for Product Categories and remove unused objects
 */
const populateProductCategoryParams = (params) => {
    // Set parent Category based on the component category_id value
    if (params.data.category_id) {
        params.data.parent_id = params.data.category_id;
    }
    if (!params.data.category_id) {
        // If a parent Category has been removed, clear parent name
        params.data.parent_id = null;
        params.data.parent_name = null;
    }

    // Remove unused form objects
    if (params.data.current_parent_id) {
        delete params.data.current_parent_id;
        delete params.data.current_parent_name;
    }
    delete params.data.category_id;

    return params;
};

/*
 * Populate values for Product Aliases and remove unused objects
 */
const populateAliasParams = (params) => {
    // Remove unused form objects
    delete params.data.current_product_unit_id;
    return params;
};

/*
 * Populate values for Discounts and remove unused objects
 * Will eventually accommodate UTC conversion and time zones
 */
const populateDiscountParams = (params) => {
    // Populate required fields
    params.data.valid_from = assembleDiscountDateTimeObject(params.data.valid_from_string, params.data.valid_from_hour, params.data.valid_from_min, params.data.valid_from_ampm);
    params.data.valid_to = assembleDiscountDateTimeObject(params.data.valid_to_string, params.data.valid_to_hour, params.data.valid_to_min, params.data.valid_to_ampm);
    params.data.short_code = params.data.short_code ? removeExtraSpaces(params.data.short_code) : '';
    params.data.name = params.data.name ? removeExtraSpaces(params.data.name) : '';
    params.data.scope = params.data.scope ? removeExtraSpaces(params.data.scope) : '';
    params.data.item_condition = params.data.item_condition ? removeExtraSpaces(params.data.item_condition) : '';
    params.data.item_action = params.data.item_action ? removeExtraSpaces(params.data.item_action) : '';

    const tzName = getLocalTimeZoneName();
    const valid_from_string = params.data.valid_from.substring(0, 10);
    params.data.valid_from_tz = valid_from_string + ' ' + tzName;

    const valid_to_string = params.data.valid_to.substring(0, 10);
    params.data.valid_to_tz = valid_to_string + ' ' + tzName;

    // Remove unused form objects
    delete params.data.add_condition_dba;
    delete params.data.add_condition_dba_include;
    delete params.data.add_condition_location;
    delete params.data.add_condition_location_include;
    delete params.data.buy_add_item_categories;
    delete params.data.buy_add_item_category;
    delete params.data.buy_add_item_product;
    delete params.data.buy_add_item_type;
    delete params.data.buy_andor;
    delete params.data.buy_qty;
    delete params.data.discount_amount;
    delete params.data.discount_amount_free;
    delete params.data.discount_type;
    delete params.data.get_add_item_categories;
    delete params.data.get_add_item_category;
    delete params.data.get_add_item_product;
    delete params.data.get_add_item_type;
    delete params.data.get_andor;
    delete params.data.get_qty;
    delete params.data.id_check;
    delete params.data.preset_custom;
    delete params.data.price_difference;
    delete params.data.valid_from_date;
    delete params.data.valid_from_string;
    delete params.data.valid_from_hour;
    delete params.data.valid_from_min;
    delete params.data.valid_from_ampm;
    delete params.data.valid_to_date;
    delete params.data.valid_to_string;
    delete params.data.valid_to_hour;
    delete params.data.valid_to_min;
    delete params.data.valid_to_ampm;

    return params;
};

/*
 * Format a new date object
 */
const assembleDiscountDateTimeObject = (dateStr, h, m, ampm) => {
    // Format: YYYY-MM-DD HH:MM:SS
    if (ampm === 'pm') {
        h = (h === '00') ? '12' : parseInt(h, 10) + 12;
    }
    return dateStr + ' ' + padDateString(h) + ':' + padDateString(m) + ':00';
};

export default (type, resource, params) => {

    /**
     * @param {string} type Request type, e.g. GET_LIST
     * @param {string} resource Resource name, e.g. "Products"
     * @param {Object} payload Request parameters. Depends on request type
     * @returns {Object} RESOURCES object
     */
    return (type, resource, params) => {
        return RESOURCES;
    }
}



// WEBPACK FOOTER //
// ./src/Fuse/fuseProductsResourceMap.js